import { render, staticRenderFns } from "./Big.vue?vue&type=template&id=370a239a"
import script from "./Big.vue?vue&type=script&lang=js"
export * from "./Big.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports